/* global Splide */
"use strict";

($dt => {

	$dt.blocks['photo-gallery'] = {

		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {

			const sliderNoVertNav = container.querySelector('.splide-without_vertical_nav');
			const sliderWithVertNav = container.querySelector('.splide-with_vertical_nav');

			if (sliderNoVertNav) {
				const options = {
					type: 'loop',
					autoplay: true,
					interval: 10000,
					pauseOnHover: true,
					pauseOnFocus: true,
					pagination: false,
					breakpoints: {
						767: {
							gap: '20px',
							padding: '0'
						},
						4000: {
							gap: '20px',
							padding: '25%'
						}
					}
				};

				new Splide(sliderNoVertNav, options).mount();
			} else {
				if (sliderWithVertNav) {
					let options = '';
					if (window.innerWidth <= 767) {
						options = {
							type: 'loop',
							autoplay: true,
							interval: 10000,
							pauseOnHover: true,
							pauseOnFocus: true,
							pagination: false,
							breakpoints: {
								767: {
									height: 160,
									perPage: 2,
									gap: '20px',
								}
							}
						};
					} else {
						options = {
							type: 'loop',
							autoplay: true,
							interval: 10000,
							pauseOnHover: true,
							pauseOnFocus: true,
							pagination: false,
							direction: 'ttb',
							breakpoints: {
								4000: {
									gap: '10px',
									perPage: 4,
									height: 560,
								},
								991: {
									height: 280,
									perPage: 2,
									gap: '10px',
								}
							}
						};
					}

					new Splide(sliderWithVertNav, options).mount();
					const photos = container.querySelectorAll('.single-photo');
					const mainDisplay = container.querySelector('.vert-nav-main-display');

					if (photos) {
						photos.forEach(element => {
							element.addEventListener("click", () => {
								photos.forEach(el => {
									el.classList.remove('active');
								});
								element.classList.add('active');
								const photoElement = document.createElement('div');
								photoElement.innerHTML = element.innerHTML;
								mainDisplay.innerHTML = '';
								mainDisplay.appendChild(photoElement);
							});
						});
					}
				}
			}
		}

	};

})(window.d3_wp_themejs);
